'use strict'
import {DOM} from '../../../../../plugins/levcharity/resources/scripts/helpers/DOM.js';

export class EditCampaign {

    #predefinedImageContainer;
    #predefinedChosenImage;
    #predefinedUploadedImage;
    constructor() {
        this.#addEvents();
        this.#predefinedImageContainer = DOM.el('.predefined-image-container');
    }

    #addEvents() {
        let inputFiles = document.querySelectorAll('input[type="file"]');
        inputFiles.forEach(input => {
            input.addEventListener("change", (event) => {
                console.log(input)
                if (input.classList.contains('feature-image') || input.classList.contains('featured-image') || input.classList.contains('banner-image') || input.classList.contains('banner_image') || input.classList.contains('additional-image')) {
                    let files = event.target.files;
                    Array.from(files).forEach(file => {
                        console.log(file)
                        const fileName = file.name;
                        const fileSize = file.size;
                        const fileSizeInKb = (fileSize / 1024).toFixed(2);

                        const img = new Image();
                        const fileURL = URL.createObjectURL(file);

                        img.onload = () => {
                            const imgWidth = img.width;
                            const imgHeight = img.height;


                            if (input.classList.contains('additional-image')) {
                                this.#addAdditionalImage(fileName, imgWidth, imgHeight, fileSizeInKb, fileURL);
                            }else if(input.classList.contains('feature-image') || input.classList.contains('featured-image')){
                                const previewGamificationFeature = document.querySelector('.preview-gamification-feature');
                                const featureImageContainer = document.querySelector('.featured-image-edit-container');
                               if (featureImageContainer){
                                   const imageDetails = featureImageContainer.querySelector('.image-details');
                                   if (imageDetails){
                                       const title = imageDetails.querySelector('.title');
                                       const resSize = imageDetails.querySelector('.resolution-size');
                                       title.textContent = fileName;
                                       resSize.textContent = imgWidth + 'x' + imgHeight + ' | ' + fileSizeInKb + "kb";
                                       previewGamificationFeature.style.display = '';
                                   }
                               }

                                const featureImage = document.querySelector('.form-group.featured-image.is-edit')
                                console.log(featureImage)
                                if (featureImage){
                                  let title =   featureImage.querySelector('.title');
                                  let titleContainer = featureImage.querySelector('.title-container');
                                  if (title && titleContainer){
                                      titleContainer.style.display= 'block'
                                      title.innerText = fileName
                                  }
                                }

                            }else if(input.classList.contains('banner-image')){
                                // this.#predefinedImageContainer.style.display = 'none';
                                // const previewGamificationBanner = document.querySelector('.preview-gamification-banner');
                                const bannerImageContainer = document.querySelector('.chaiathon-campaign-image-wrapper');
                                const previewGamificationBanner = document.querySelector('.preview-gamification-banner');



                                if (bannerImageContainer){
                                    const imageDetails = bannerImageContainer.querySelector('.campaign_image_meta');

                                    if (imageDetails){
                                        const title = imageDetails.querySelector('.bannered_image_name');
                                        const resSize = imageDetails.querySelector('.bannered_image_metadata');
                                    }
                                }
                                if (previewGamificationBanner){
                                    previewGamificationBanner.style.display = 'block'
                                }

                                const bannerImagePreview = DOM.el('.banner-image-preview')
                                if (bannerImagePreview){
                                    // bannerImagePreview.srcset = img.src
                                    bannerImagePreview.src = img.src
                                    this.#predefinedUploadedImage = img.src
                                }

                            }



                        };

                        img.src = fileURL;
                        let image =  document.querySelector('.campaign_image img');
                        if(image)
                        image.src = fileURL
                        if (document.querySelector('.campaign_image img')){
                            // document.querySelector('.campaign_image img').srcset = fileURL;
                        }
                    });
                }
            });
        });

        const removeBannerImage = DOM.el('.remove-banner-image-button')
        DOM.addEvent('click', removeBannerImage, () => {
            DOM.el('.preview-gamification-banner').style.display = 'none';
            this.#predefinedImageContainer.style.display = '';
            const bannerImage = DOM.el('input[name="banner_image"]');
            bannerImage.value = '';
            this.#predefinedUploadedImage = '';
        })

        const removeProfilePitcture = DOM.el('.remove-profile-picture-button')
        DOM.addEvent('click', removeProfilePitcture, () => {
            DOM.el('.preview-gamification-banner').style.display = 'none';
            const profilePicture = DOM.el('input[name="banner_image"]');
            profilePicture.value = '';
        })

        const removeAdditionalImage = DOM.el('.remove-additional-image-button')
        DOM.addEvent('click', removeProfilePitcture, () => {
            DOM.el('.preview-gamification-banner').style.display = 'none';
            const profilePicture = DOM.el('input[name="banner_image"]');
            profilePicture.value = '';
        })

        DOM.addEvent('click', '.predefined-image-item input', (event)=>{
            if (event.target.matches('.predefined-image-item input')) {
                const imageItem = event.target.closest('.predefined-image-item');
                this.#predefinedChosenImage = imageItem.querySelector('img')?.src;
            }
        })

        DOM.addEvent('click', '.remove-feature-image-button', (event) => {
            const featuredImage = event.target.closest('.featured-image');
            if (!featuredImage) return;

            const img = featuredImage.querySelector('.preview img');
            const input = featuredImage.querySelector('input');
            const titleContainer = featuredImage.querySelector('.title-container');

            if (img) img.src = '';
            if (input) input.value = '';
            if (titleContainer) titleContainer.style.display = 'none';
        });


        DOM.addEvent('click', '.banner-image-preview .edit-button', (event) => {
            const container = event.target.closest('.banner-image-edit-container');

            if (container && !container.classList.contains('is-edit')) {
                const bannerImage = DOM.el('.banner-image-preview img');

                if (bannerImage && !this.#predefinedUploadedImage) {
                    if (this.#predefinedChosenImage) {
                        bannerImage.src = this.#predefinedChosenImage;
                    }
                }
            }
        });



    }

    #addAdditionalImage(fileName, imgWidth, imgHeight, fileSizeInKb, fileURL) {
        const imageContainer = document.querySelector('.additional-images-container');
        const imageWrapper = document.createElement('div');
        imageWrapper.classList.add('image-wrapper');
        imageWrapper.style.position = 'relative';

        const img = document.createElement('img');
        img.src = fileURL;
        img.alt = fileName;
        img.style.width = '100px';
        img.style.height = '100px';
        img.style.borderRadius = '4px';
        img.style.objectFit = 'cover';
        img.style.marginRight = '10px';

        const deleteBtn = document.createElement('button');
        deleteBtn.textContent = 'X';
        deleteBtn.classList.add('delete-btn');
        deleteBtn.addEventListener('click', () => {
            imageWrapper.remove();
        });

        imageWrapper.appendChild(img);
        imageWrapper.appendChild(deleteBtn);
        imageContainer.appendChild(imageWrapper);

        imageContainer.style.display = 'flex';
    }
}
